
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmiley5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 42,
  height: 20,
  textRendering: "geometricPrecision",
  viewBox: "0 0 42 20"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "smiley5_507f2e6ddf4a2e06__a",
  width: 42,
  height: 20,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAUCAMAAADMbV+0AAAALVBMVEVMaXH///////////////////////////////////////////////////////9xAJ22AAAADnRSTlMA8NAwWX+8EOAgQKBvkM+/YmMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAC1SURBVHjalZLbEsMgCAWPinhB/f/PraZOkyiTtvuWDRMOEABwRdi0DrOnhEkizzysYSluGIrtjvWDahcdCab9iEH9tbQCZbfW7o5G2s1bICqu45UP0Or8UUpbfiAYrT/SYovWKryXzUqqZQKed3HXbmaeK92kw15rT2mVyj5FjfN64SLLlP4iD3LOWAma/JvU5HyQ5p5KTZMZLMhnGTq5TzH+4zxGcs8RzhVZ9zUvSb8eC21vXv+wF0rSbn0xAAAAAElFTkSuQmCC",
  width: 42,
  height: 20,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAUCAMAAADMbV+0AAAALVBMVEVMaXH///////////////////////////////////////////////////////9xAJ22AAAADnRSTlMA8NAwWX+8EOAgQKBvkM+/YmMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAC1SURBVHjalZLbEsMgCAWPinhB/f/PraZOkyiTtvuWDRMOEABwRdi0DrOnhEkizzysYSluGIrtjvWDahcdCab9iEH9tbQCZbfW7o5G2s1bICqu45UP0Or8UUpbfiAYrT/SYovWKryXzUqqZQKed3HXbmaeK92kw15rT2mVyj5FjfN64SLLlP4iD3LOWAma/JvU5HyQ5p5KTZMZLMhnGTq5TzH+4zxGcs8RzhVZ9zUvSb8eC21vXv+wF0rSbn0xAAAAAElFTkSuQmCC",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#smiley5_507f2e6ddf4a2e06__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h42v20H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"42\" height=\"20\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 42 20\"><defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAUCAMAAADMbV+0AAAALVBMVEVMaXGSNOiSNOiINuaPNuaPNuaPNuaZL+mQOOWML+mOM+ePNuaTN+eSNOiQN+fj1tPeAAAADnRSTlMA8NAwWX+8EOAgQKBvkM+/YmMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAC1SURBVHjalZLbEsMgCAWPinhB/f/PraZOkyiTtvuWDRMOEABwRdi0DrOnhEkizzysYSluGIrtjvWDahcdCab9iEH9tbQCZbfW7o5G2s1bICqu45UP0Or8UUpbfiAYrT/SYovWKryXzUqqZQKed3HXbmaeK92kw15rT2mVyj5FjfN64SLLlP4iD3LOWAma/JvU5HyQ5p5KTZMZLMhnGTq5TzH+4zxGcs8RzhVZ9zUvSb8eC21vXv+wF0rSbn0xAAAAAElFTkSuQmCC\" id=\"convert2-source\" width=\"42\" height=\"20\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAUCAMAAADMbV+0AAAALVBMVEVMaXGSNOiSNOiINuaPNuaPNuaPNuaZL+mQOOWML+mOM+ePNuaTN+eSNOiQN+fj1tPeAAAADnRSTlMA8NAwWX+8EOAgQKBvkM+/YmMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAC1SURBVHjalZLbEsMgCAWPinhB/f/PraZOkyiTtvuWDRMOEABwRdi0DrOnhEkizzysYSluGIrtjvWDahcdCab9iEH9tbQCZbfW7o5G2s1bICqu45UP0Or8UUpbfiAYrT/SYovWKryXzUqqZQKed3HXbmaeK92kw15rT2mVyj5FjfN64SLLlP4iD3LOWAma/JvU5HyQ5p5KTZMZLMhnGTq5TzH+4zxGcs8RzhVZ9zUvSb8eC21vXv+wF0rSbn0xAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/><mask id=\"layer-0\" width=\"42\" height=\"20\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAUCAMAAADMbV+0AAAALVBMVEVMaXH///////////////////////////////////////////////////////9xAJ22AAAADnRSTlMA8NAwWX+8EOAgQKBvkM+/YmMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAC1SURBVHjalZLbEsMgCAWPinhB/f/PraZOkyiTtvuWDRMOEABwRdi0DrOnhEkizzysYSluGIrtjvWDahcdCab9iEH9tbQCZbfW7o5G2s1bICqu45UP0Or8UUpbfiAYrT/SYovWKryXzUqqZQKed3HXbmaeK92kw15rT2mVyj5FjfN64SLLlP4iD3LOWAma/JvU5HyQ5p5KTZMZLMhnGTq5TzH+4zxGcs8RzhVZ9zUvSb8eC21vXv+wF0rSbn0xAAAAAElFTkSuQmCC\" width=\"42\" height=\"20\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAUCAMAAADMbV+0AAAALVBMVEVMaXH///////////////////////////////////////////////////////9xAJ22AAAADnRSTlMA8NAwWX+8EOAgQKBvkM+/YmMAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAC1SURBVHjalZLbEsMgCAWPinhB/f/PraZOkyiTtvuWDRMOEABwRdi0DrOnhEkizzysYSluGIrtjvWDahcdCab9iEH9tbQCZbfW7o5G2s1bICqu45UP0Or8UUpbfiAYrT/SYovWKryXzUqqZQKed3HXbmaeK92kw15rT2mVyj5FjfN64SLLlP4iD3LOWAma/JvU5HyQ5p5KTZMZLMhnGTq5TzH+4zxGcs8RzhVZ9zUvSb8eC21vXv+wF0rSbn0xAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><rect width=\"42\" height=\"20\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/smiley5.507f2e6ddf4a2e06862e1100e8cd18bb.svg"),
        {
          React: SvgSmiley5,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      